// /* eslint no-param-reassign: "error" */
//
export default {
  setAllIndexations(state, indexations) {
    state.indexations = indexations;
  },
  addIndexation(state, indexation) {
    state.indexations.push(indexation);
  },
  editIndexation(state, indexation) {
    const index = state.indexations.findIndex(element => element.id === indexation.id);
    state.indexations[index] = indexation;
  }
};
